module.exports = __webpack_public_path__ + "img/bead.55eabfc2.jpg";